package com.milta.core.localization.translations.ro

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Import — Foto",
    titlePdf = "Import — PDF",
    titleSpreadsheet = "Import — Excel / CSV",
    fileSentSuffix = "trimis chiar acum",
    fileWaitingConnectionLabel = "în așteptarea conexiunii",
    analysingTitle = "Se citește documentul…",
    analysingSubtitle = "Extragerea livrărilor poate dura câteva secunde.",
    analysingSubtitlePdf = "Claude Haiku extrage livrările — poate dura câteva secunde pe un PDF scanat.",
    stepFileSent = "Fișier trimis",
    stepExtracting = "Extragerea câmpurilor",
    stepReview = "Verificare înainte de adăugare",
    successTitle = "Livrare detectată",
    successSubtitle = "Verificați informațiile înainte de a le adăuga la traseu.",
    addToRouteButton = "Adaugă la traseu",
    scanAnotherButton = "Scanează alt document",
    partialTitle = "Aproape complet",
    partialSubtitle = "Un câmp nu a putut fi citit pe document.",
    missingFieldPlaceholder = "De completat…",
    partialBannerText = "Unele informații nu au putut fi citite. Puteți valida ca atare și le puteți completa mai târziu, sau puteți retrimite un document mai clar.",
    retryFileButton = "Retrimite alt fișier",
    validateAndContinueButton = "Validează și continuă",
    attemptLabel = "Încercare",
    errorTitleUnreadable = "Document ilizibil",
    errorTitleMissingFields = "Informații negăsite",
    errorTitleNetworkError = "Problemă la analiză",
    errorTitleGeneric = "Analiza a eșuat",
    errorSubtitle = "Nu am putut detecta o livrare pe acest fișier.",
    errorBannerSuffixUnreadable = "imagine prea întunecată sau text tăiat. Faceți o fotografie bine cadrată și bine luminată, sau trimiteți un fișier mai clar.",
    errorBannerSuffixMissingFields = "nu s-a găsit nicio informație utilizabilă. Verificați conținutul fișierului sau trimiteți altul.",
    errorBannerSuffixNetworkError = "serviciul de analiză a avut o problemă de rețea. Reîncercați în câteva momente.",
    errorBannerSuffixGeneric = "a apărut o eroare neașteptată în timpul analizei. Reîncercați sau trimiteți alt fișier.",
    retryWithNewFileButton = "Reîncearcă cu alt fișier",
    manualEntryButton = "Introduce manual",
    attemptsRemainingNote = "Mai aveți 1 încercare pentru acest document.",
    maxAttemptsTitle = "Încă ilizibil",
    maxAttemptsSubtitle = "Acest document nu a putut fi citit după 2 încercări.",
    maxAttemptsBanner = "Limita de încercări a fost atinsă pentru acest document. Completați livrarea manual sau reluați importul cu un document nou.",
    retryUnavailableButton = "Reîncearcă — indisponibil",
    newDocumentButton = "Importă un document nou",
    serviceUnavailableTitle = "Serviciu temporar indisponibil",
    serviceUnavailableSubtitle = "Analiza automată nu răspunde momentan.",
    serviceUnavailableBanner = "Reîncercați în câteva momente sau completați livrarea manual în așteptare.",
    offlineTitle = "Sunteți offline",
    offlineSubtitle = "Fișierul dvs. este pregătit, dar nu a fost încă trimis.",
    offlineBanner = "Reconectați-vă la internet, apoi relansați analiza. Nimic nu a fost trimis pe server — nu s-a contorizat nicio încercare.",
    retryOfflineButton = "Reîncearcă — fără conexiune",
    unsupportedFormatBanner = "Format de fișier neacceptat. Alegeți o fotografie, un PDF sau un fișier Excel/CSV.",
    validationTitle = "Verificați livrările",
    fileRejectedTitle = "Fișier netrimis",
    fileRejectedSubtitle = "Alegeți alt fișier pentru a continua.",
    bannerFileRequired = "nu a fost selectat niciun fișier. Alegeți un fișier PDF pentru a continua.",
    bannerInvalidPdfFormat = "format neacceptat. Aici sunt acceptate doar fișiere PDF.",
    bannerFileTooLarge = "fișier prea mare. Alegeți un fișier PDF mai ușor.",
    chooseAnotherFileButton = "Alege alt fișier",
)
